export default {
    updateJSON: ({ commit }, payload) => {
      commit("updateJSON", payload);
    }
  };
  